/**
 * DATA LAYER: TOMBOLA (LIVE BADGE) OVERLAY
 * Se encarga de la comunicación HTTP con la API de Tombola.
 */

export const GetTombolaConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/config`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SetTombolaConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ShowTombolaOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/show`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const HideTombolaOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/hide`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

// Contacto HTTP methods
export const GetContactoConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/contacto/config`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SetContactoConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/contacto/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ShowContactoOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/contacto/show`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const HideContactoOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/contacto/hide`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const CreateContactoItem = async (item) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/contacto/items`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(item)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const UpdateContactoItem = async (id, item) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/contacto/items/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(item)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const DeleteContactoItem = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/contacto/items/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SelectContactoItem = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/contacto/items/select/${id}`, {
            method: 'POST'
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ToggleContactoVisibility = async (visible) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/contacto/toggle-visibility`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ visible })
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

// Portada HTTP methods
export const GetPortadaConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/portada/config`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SetPortadaConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/portada/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ShowPortadaOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/portada/show`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const HidePortadaOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/portada/hide`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const GetSoporteConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/soporte/config`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SetSoporteConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/soporte/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ShowSoporteOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/soporte/show`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const HideSoporteOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/soporte/hide`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

// Cumpleanos HTTP methods
export const GetCumpleanosConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/cumpleanos`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SetCumpleanosConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/cumpleanos`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ShowCumpleanosOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/cumpleanos/show`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const HideCumpleanosOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/cumpleanos/hide`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

// LiveBadgeItem CRUD methods
export const CreateLiveBadgeItem = async (item) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/badge-items`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(item)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const UpdateLiveBadgeItem = async (id, item) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/badge-items/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(item)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const DeleteLiveBadgeItem = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/badge-items/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SelectLiveBadgeItem = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/badge-items/select/${id}`, {
            method: 'POST'
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ToggleLiveBadgeLogo = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}tombola/badge-items/toggle-logo/${id}`, {
            method: 'POST'
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

